export const userStatus = (state, user) => {
  if (user) {
    state.currentUser = user;
    state.isLogin = true;
  } else if (user == null) {
    window.sessionStorage.setItem('currentUser', null);
    window.sessionStorage.setItem('isLogin', false);
    state.currentUser = null;
    state.isLogin = false;
  }
};
